import { defineMessages } from "react-intl";

const messages = defineMessages({
    play: {
        id: "audio.play",
    },
    check: {
        id: "audio.check",
    },
    submit: {
        id: "task.submit",
    },
    tryAgain: {
        id: "task.tryAgain",
    },
});

export default messages;
